import React from "react";
import { EventsList } from "../../components/Events/EventsList";
import { Row, Col } from "react-bootstrap";
import {
  StyledSectionHeaderComponent,
  StyledListContainer,
  StyledListSection,
  StyledListSideBarColumn,
} from "../../utils/common-styles";

import { Volunteering } from "../../components/Sidebar/General/Volunteering.jsx";
import { ReportIssue } from "../../components/Sidebar/General/ReportIssue.jsx";
import { BecomeAMember } from "../../components/Sidebar/General/BecomeAMember.jsx";
import { Helmet } from "react-helmet";
import { UrlFixer } from "../../utils/utils";


export const EventsListPage = () => {
  return (
    <>
      <Helmet>
        <title>Upcoming events from Queen's Wood</title>
        <meta name="description" content="Upcoming events from Queen's Wood" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Upcoming events from Queen\'s Wood" />
        <meta property="og:description" content="Upcoming events from Queen's Wood" />
        <meta property="og:url" content={`${window.location.origin}`} />
        <meta property="og:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
        <meta name="twitter:title" content="Upcoming events from Queen\'s Wood" />
        <meta name="twitter:description" content="Upcoming events from Queen's Wood" />
        <meta name="twitter:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
      </Helmet>
      <StyledSectionHeaderComponent title="Upcoming events" />
      <StyledListSection>
        <StyledListContainer>
          <Row>
            <Col xs={12} md={9}>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>
              <EventsList /></Col>
            <StyledListSideBarColumn xs={12} md={3}>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>
              <ReportIssue />
              <Volunteering />
              <BecomeAMember />
            </StyledListSideBarColumn>
          </Row>
        </StyledListContainer>
      </StyledListSection>
    </>
  );
};
